import { render, staticRenderFns } from "./CourseEdit.html?vue&type=template&id=7d16e57e&scoped=true&external"
import script from "./CourseEdit.ts?vue&type=script&lang=ts&external"
export * from "./CourseEdit.ts?vue&type=script&lang=ts&external"
import style0 from "./CourseEdit.scss?vue&type=style&index=0&id=7d16e57e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d16e57e",
  null
  
)

export default component.exports